import React from "react";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { Box, IconButton } from "@mui/material";
import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import { CustomSpinner } from "../components/CustomSpinner";
import {
  useUserInvitations,
  useDeleteUserInvitation,
  UserInvitation,
} from "../requests/userInvitations";
import { LARGE_COLUMN, XXL_COLUMN } from "../utils/columnSizes";
import { UserPermission, useUser } from "../requests/users";
import { useState } from "react";
import { AlertDialog } from "../components/AlertDialog";

export const UserInvitations = () => {
  const { data: invitations, isLoading } = useUserInvitations();
  const deleteInvitation = useDeleteUserInvitation();
  const user = useUser();
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [selectedInvitation, setSelectedInvitation] = useState<UserInvitation | null>(null);

  const columns: GridColDef[] = [
    { field: "email", headerName: "Email", width: XXL_COLUMN },
    {
      field: "created_at",
      headerName: "Invited On",
      width: LARGE_COLUMN,
      valueFormatter: (params) => new Date(params.value as string).toLocaleDateString(),
    },
    {
      field: "expires_at",
      headerName: "Expires",
      width: LARGE_COLUMN,
      valueFormatter: (params) => new Date(params.value as string).toLocaleDateString(),
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 100,
      renderCell: (params) => (
        <IconButton
          onClick={() => {
            setSelectedInvitation(params.row as UserInvitation);
            setDeleteDialogOpen(true);
          }}
        >
          <DeleteIcon />
        </IconButton>
      ),
    },
  ];

  if (isLoading || !invitations) {
    return <CustomSpinner />;
  }

  if (!user || user.permission_level_id !== UserPermission.owner) {
    return <Box p={2}>You must be an owner to view invitations.</Box>;
  }

  const handleDelete = () => {
    if (selectedInvitation) {
      deleteInvitation.mutate(selectedInvitation.id);
      setDeleteDialogOpen(false);
      setSelectedInvitation(null);
    }
  };

  return (
    <Box sx={{ height: "calc(100vh - 120px)", width: "100%", p: 2 }}>
      <DataGrid
        rows={invitations}
        columns={columns}
        initialState={{
          sorting: {
            sortModel: [{ field: "created_at", sort: "desc" }],
          },
        }}
        disableRowSelectionOnClick
      />
      <AlertDialog
        isOpen={deleteDialogOpen}
        onCloseDialog={() => setDeleteDialogOpen(false)}
        onConfirmDialog={handleDelete}
        title="Delete Invitation"
        message={`Delete invitation for ${selectedInvitation?.email}?`}
      />
    </Box>
  );
};
